type VodGuidItem = {
    guid?: string;
    seriesGuid?: string;
    seriesGUID?: string | null;
    seriesId?: string;
};

export const getVodItemGuid = (item: VodGuidItem | null | undefined): string => {
    if (!item?.guid) {
        return '';
    }
    if (item.guid.includes('SEASON')) {
        const seriesGuid = item.seriesGuid || item.seriesGUID;
        if (seriesGuid) {
            return seriesGuid;
        }
        if (item.seriesId) {
            try {
                const urlParts = new URL(item.seriesId).pathname.split('/');
                return urlParts[urlParts.length - 1] || item.guid;
            } catch {
                return item.guid;
            }
        }
    }
    return item.guid;
};

export const filterByIdsWithEpisodes = (bookmarks, ep) => {
    const idSet = ep && ep.length > 0 && new Set(ep.map((item) => item.Id));
    return idSet && bookmarks && bookmarks.filter((item) => idSet.has(item.Id));
};

export const filterByIds = (bookmarks, item) => {
    return bookmarks && bookmarks.filter((bkmark) => bkmark.Id == item.Id);
};
